import * as yup from 'yup';
import { RendererType } from '../../../data-models/field-definition';
import { ISelectMeta } from '../../../data-models/field3.data-model';
import { clientConfigFields } from '../../../schemas/ClientConfig.schema';
import { schemaToFormFields } from '../../../util/schema-utils';

/**
 * Client (application settings) config schema: the form fields picked from the
 * shared clientConfigFields() builders, with the one presentation override the
 * config form needs (type single-select). key/value are plain strings and
 * default to the text renderer. Reusing the shared builders keeps validation
 * and defaults in sync with the canonical schema.
 *
 * NOTE: `key` inherits a `.oneOf(ClientConfigKey)` constraint from the shared
 * builder. This is inert today because the config form (ConfigModal) renders
 * from IFormField descriptors and runs no yup resolver — only `required` is
 * read off the schema. If a yup resolver is ever wired into the modal, that
 * `.oneOf` would start rejecting any free-text key not in the enum; relax it
 * here (or drop the reuse) before doing so.
 */
export function clientConfigFormSchema() {
  const fields = clientConfigFields();
  return yup
    .object(fields)
    .pick(['key', 'type', 'value'])
    .shape({
      type: fields.type.formMeta({
        renderer: RendererType.singleSelect,
        rendererMeta: {
          values: [
            { value: 'boolean', displayName: 'Boolean' },
            { value: 'string', displayName: 'String' },
            { value: 'number', displayName: 'Number' },
          ],
        } as ISelectMeta<string>,
      }),
    });
}

export function getClientConfigFields() {
  return schemaToFormFields(clientConfigFormSchema(), ['key', 'type', 'value']);
}
